
import { Component, ChangeDetectorRef, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { ApiService } from '../../../service/api.service';
import { Router } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialog } from '@angular/material/dialog';
import { UtilsService } from 'src/app/service/helper/utils.service';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import { timer, interval } from 'rxjs';
import am4lang_it_IT from "@amcharts/amcharts4/lang/it_IT";
import { AuthenticationService } from '../../../service/authentication.service';
import { CallstatusService } from '../callstatus/callstatus.service';
import { Callstatus } from '../callstatus/callstatus.model';
import Speech from 'speak-tts'
import { EmergenciesstatusService } from '../emergenciesstatus/emergenciesstatus.service';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';;
import { Emergenciesstatus } from '../emergenciesstatus/emergenciesstatus.model';
import { Subscription } from 'rxjs';
import { MatSort } from '@angular/material/sort';

let vh = window.innerHeight * 0.01;
let vw = window.innerWidth * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);
document.documentElement.style.setProperty('--vw', `${vw}px`);
window.addEventListener('resize', () => {
  // We execute the same script as before
  let vh = window.innerHeight * 0.01;
  let vw = window.innerWidth * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
  document.documentElement.style.setProperty('--vw', `${vw}px`);
});
// classe "User" contenente tutte le informazioni utente restituite dal back-end
// classe User utilizzata per definire il contenuto degli oggetti di tipo utente scambiati col back-end
export class User {
  username: string;
  cryptedusername: string;
  token: string;

}
@Component({
  selector: 'day_mobile',
  templateUrl: './day_mobile.component.html',
  styleUrls: ['./mobile.component.scss'],

})
export class DayMobileComponent implements OnInit {
  public user: User;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild('chartElementMI', { static: false }) chartElementMI: ElementRef<HTMLElement>;
  @ViewChild('chartElementMA', { static: false }) chartElementMA: ElementRef<HTMLElement>;
  @ViewChild('chartElementMAA', { static: false }) chartElementMAA: ElementRef<HTMLElement>;

  constructor(
    private authService: AuthenticationService,
    private utilsService: UtilsService,
    public dialog: MatDialog,
    private storageService: ApiService,

  ) {
  }
  periods = ["Ultime 24 ore rilevate", "Ultimi 7 giorni rilevati [W]", "Ultimi 30 giorni rilevati [W]", "Anno corrente [W]", "Da sempre [W]"]
  periods2 = ["Ultimi dati istantanei", "Media ultime 24 ore", "Media ultimi 7 giorni", "Media ultimi 30 giorni", "Media ultimo anno", "Media totale"]
  weatherurl = "https://api.openweathermap.org/data/2.5/onecall?lat=45.6363&lon=10.0457&appid=9ca6785c4922357ad5c7ec66a28c0530&exclude=minutely,current&units=metric&lang=it";
  color = {
    white: '#fff',
    black: '#000',
    grey: '#7e8596',
    temperature: '#ED953A',
    humidity: '#7FB9F2',
    distance: '#FFF2AB',
    ec: '#C1FFBF',
    ph: '#fd5189',
    lightblue: '#c0d8ff'

  };
  pageEvent: PageEvent;

  totalalarms
  // inizializzazione id, profilo e array con tutti gli indici dei messaggi nella tabella
  public id: number
  profile: string
  index = []
  totplants = []
  totalarms = []
  total
  todaysent
  monthsent
  totalsent
  dailymean
  monthlymean
  totalavailables


  // al richiamo della sidebar viene importato l'utente corrente leggendolo dal componente di autenticazione e viene assegnato un id
  // a tutti gli elementi degli array BUTTONS, BUTTONS2 e BUTTONS3 

  ngOnInit() {
    this.storageService.getPlantsTot().subscribe(v => {
      this.totplants = v.sort()
    })
    this.storageService.getAlarmcodesTot().subscribe(v => {
      this.totalarms = v.sort()
    })
    this.storageService.getEmergenciesstatuscount()
    this.createChart()
    this.createChartAlarm()
    this.createChartAvailables()
  }
  createChart() {
    var me = this
    this.storageService.piedata().subscribe(result => {
      const chart = am4core.create(me.chartElementMI.nativeElement, am4charts.PieChart);
      chart.language.locale = am4lang_it_IT;
      chart.numberFormatter.language = new am4core.Language();
      chart.numberFormatter.language.locale = am4lang_it_IT;
      chart.dateFormatter.language = new am4core.Language();
      chart.dateFormatter.language.locale = am4lang_it_IT;
      chart.logo.disabled = true;
      this.todaysent = parseInt(result.body.smstoday) + parseInt(result.body.mailtoday) + parseInt(result.body.ttstoday)

      chart.data = [{
        "canale": "SMS",
        "invii": parseInt(result.body.smstoday)
      }, {
        "canale": "Mail",
        "invii": parseInt(result.body.mailtoday)
      }, {
        "canale": "Voce",
        "invii": parseInt(result.body.ttstoday)
      }];
      let pieSeries = chart.series.push(new am4charts.PieSeries());
      pieSeries.dataFields.value = "invii";
      pieSeries.dataFields.category = "canale";
      pieSeries.innerRadius = am4core.percent(50);
      pieSeries.ticks.template.disabled = true;
      pieSeries.labels.template.disabled = true;

      let rgm = new am4core.RadialGradientModifier();
      rgm.brightnesses.push(-0.8, -0.8, -0.5, 0, - 0.5);
      pieSeries.slices.template.fillModifier = rgm;
      pieSeries.slices.template.strokeModifier = rgm;
      pieSeries.slices.template.strokeOpacity = 0.4;
      pieSeries.slices.template.strokeWidth = 0;

      chart.legend = new am4charts.Legend();
      chart.legend.position = "right";
      chart.legend.fontSize = 10;
      chart.legend.maxHeight = 100;
      var markerTemplate = chart.legend.markers.template;
      markerTemplate.width = 15;
      markerTemplate.height = 15;

      chart.legend.labels.template.fill = am4core.color("white");
      chart.legend.valueLabels.template.fill = am4core.color("white");

    })

    this.utilsService.hideLoader();
  }
  createChartAlarm() {
    var me = this
    this.storageService.emergenciesdashboard("mobile", [], []).subscribe(result => {
      const chart = am4core.create(me.chartElementMA.nativeElement, am4charts.XYChart);
      chart.data = result.body;
      var total = result.body.reduce((accum, item) => accum + parseInt(item.value), 0)
      this.totalalarms = total

      result.body.forEach(v => {
        v.timestamp = new Date(v.timestamp).getHours()
        v.timestamp <= 9 ? v.timestamp = "0" + v.timestamp + ":00" : v.timestamp = v.timestamp + ":00"
      })
      //   chart.legend = new am4charts.Legend();
      //   chart.legend.labels.template.fill = am4core.color("white");
      chart.language.locale = am4lang_it_IT;
      chart.numberFormatter.language = new am4core.Language();
      chart.numberFormatter.language.locale = am4lang_it_IT;
      chart.dateFormatter.language = new am4core.Language();
      chart.dateFormatter.language.locale = am4lang_it_IT;
      chart.logo.disabled = true;

      // Create axes
      let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "timestamp";
      categoryAxis.renderer.labels.template.rotation = 270;
      categoryAxis.renderer.labels.template.hideOversized = false;
      categoryAxis.renderer.minGridDistance = 20;
      categoryAxis.renderer.labels.template.verticalCenter = "middle";
      categoryAxis.renderer.labels.template.fontSize = 10;

      categoryAxis.tooltip.label.rotation = 270;
      categoryAxis.tooltip.label.horizontalCenter = "right";
      categoryAxis.tooltip.label.verticalCenter = "middle";
      categoryAxis.renderer.labels.template.fill = am4core.color(this.color.white);
      var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      //   valueAxis.title.text = "SMS/giorno";
      //   valueAxis.title.fill = am4core.color("white");
      valueAxis.renderer.labels.template.fill = am4core.color(this.color.white);
      valueAxis.renderer.labels.template.fontSize = 10;
      valueAxis.renderer.minGridDistance = 15;
      valueAxis.max = Math.max(...result.body.map(o => o.value));
      valueAxis.min = 0;
      valueAxis.strictMinMax = true;
      // Create series
      let series = chart.series.push(new am4charts.LineSeries());
      series.dataFields.valueY = "value";
      series.dataFields.categoryX = "timestamp";
      series.fill = am4core.color("blue");
      series.stroke = am4core.color("blue");
      series.zIndex = 100;
      series.fillOpacity = 0.7;
      series.tooltip.background.fill = series.fill;

      var currentSlice;
      series.segments.template.events.on("hit", function (ev) {
        if (currentSlice) {
          currentSlice.tooltip.hide();
        }
        currentSlice = ev.target;
        currentSlice.tooltipText = "{categoryX}: {valueY} Allarmi";
        currentSlice.invalidate();
        currentSlice.showTooltip();
      });
    })
    this.utilsService.hideLoader();
  }
  emergenciesstatus(): void {
    this.dialog.open(DayEmergenciesstatusInt, {
      width: '100vw',
    });
  }
  availabilities(): void {
    this.dialog.open(AvailabilitiesIntD, {
      width: '100vw',
    });
  }
  callstatus(): void {
    this.dialog.open(DayCallstatusInt, {
      width: '100vw',
    });
  }
  createChartAvailables() {
    var me = this
    this.storageService.availablesdashboard().subscribe(result => {
      const chart = am4core.create(me.chartElementMAA.nativeElement, am4charts.XYChart);
      chart.data = result;
      var total = result.reduce((accum, item) => accum + parseInt(item.value), 0)
      this.totalavailables = total
      //   chart.legend = new am4charts.Legend();
      //   chart.legend.labels.template.fill = am4core.color("white");
      chart.language.locale = am4lang_it_IT;
      chart.numberFormatter.language = new am4core.Language();
      chart.numberFormatter.language.locale = am4lang_it_IT;
      chart.dateFormatter.language = new am4core.Language();
      chart.dateFormatter.language.locale = am4lang_it_IT;
      chart.logo.disabled = true;

      // Create axes
      let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "groupid";
      categoryAxis.renderer.labels.template.rotation = 270;
      categoryAxis.renderer.labels.template.hideOversized = false;
      categoryAxis.renderer.minGridDistance = 10;
      categoryAxis.renderer.labels.template.horizontalCenter = "right";
      categoryAxis.renderer.labels.template.verticalCenter = "middle";
      categoryAxis.tooltip.label.rotation = 270;
      categoryAxis.tooltip.label.horizontalCenter = "right";
      categoryAxis.tooltip.label.verticalCenter = "middle";
      categoryAxis.renderer.labels.template.fill = am4core.color(this.color.white);
      categoryAxis.renderer.labels.template.fontSize = "0.5em"
      var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      //   valueAxis.title.text = "SMS/giorno";
      //   valueAxis.title.fill = am4core.color("white");
      valueAxis.renderer.labels.template.fill = am4core.color(this.color.white);
      valueAxis.renderer.labels.template.fontSize = 10;
      valueAxis.renderer.minGridDistance = 15;
      valueAxis.max = Math.max(...result.map(o => o.value));
      valueAxis.min = 0;
      valueAxis.strictMinMax = true;
      // Create series
      let series = chart.series.push(new am4charts.ColumnSeries());
      series.dataFields.valueY = "value";
      series.dataFields.categoryX = "groupid";
      series.fill = am4core.color("blue");
      series.stroke = am4core.color("blue");
      series.zIndex = 100;
      series.fillOpacity = 0.7;
      series.tooltip.background.fill = series.fill;

      var currentSlice;
      series.columns.template.events.on("hit", function (ev) {
        if (currentSlice) {
          currentSlice.tooltip.hide();
        }
        currentSlice = ev.target;
        currentSlice.tooltipText = "{categoryX}: {valueY} Reperibili";
        currentSlice.invalidate();
        currentSlice.showTooltip();
      });


    })
    this.utilsService.hideLoader();
  }

  logOut() {
    localStorage.clear();
    localStorage.removeItem('currentUser');
    localStorage.removeItem('currentUserComplete');
    this.authService.logout();
  }
}
@Component({
  templateUrl: 'emergenciesstatus.html',
  styleUrls: ['./mobile.component.scss']
})

export class DayEmergenciesstatusInt implements OnInit {
  private subscription: Subscription;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(
    public dialogRef: MatDialogRef<Emergenciesstatus>,
    public ApiService: ApiService,
    private storageService: ApiService,
    private emergenciesstatusService: EmergenciesstatusService,
    private changeDetectorRefs: ChangeDetectorRef,

    @Inject(MAT_DIALOG_DATA) public data) { }
  urls;
  chart2
  color = {
    white: '#fff',
    black: '#000',
    grey: '#7e8596',
    temperature: '#ED953A',
    humidity: '#7FB9F2',
    distance: '#FFF2AB',
    ec: '#C1FFBF',
    ph: '#fd5189',

  };
  pageSize = 10
  dataSource: MatTableDataSource<Emergenciesstatus>;
  itemCount = 1000
  displayedColumns: string[] = ['timestamp', 'plant', 'message'];
  speech

  ngOnInit() {
    this.speech = new Speech()
    this.speech
      .init({
        volume: 1,
        lang: "it-IT",
        rate: 0.7,
        pitch: 1,
        //'splitSentences': false,
        listeners: {
          onvoiceschanged: (voices) => {
          }
        }
      })
      .then((data) => {
      })
      .catch((e) => {
      });
    this.getData(0, this.pageSize)

  }
  public getServerData(event?: PageEvent) {
    this.getData(event.pageIndex, event.pageSize)
  }
  getData(pageIndex, pageSize) {
    this.storageService.getEmergenciesstatusmobile(pageIndex, pageSize, { timeFilter: "mobile" });
    this.dataSource = new MatTableDataSource(this.emergenciesstatusService.getEmergenciesstatus());
    this.subscription = this.emergenciesstatusService.emergenciesstatusChanged.subscribe(
      (emergenciesstatuss: Emergenciesstatus[]) => {
        this.dataSource = new MatTableDataSource(emergenciesstatuss);
        this.dataSource.sort = this.sort;
        this.changeDetectorRefs.detectChanges();
      }
    );
    this.subscription = this.emergenciesstatusService.emergenciesstatuscountChanged.subscribe(
      (emergenciesstatusscount: string) => {
        this.itemCount = parseInt(emergenciesstatusscount);
      }
    );
  }
  tts(message) {
    this.speech.speak({
      text: message.code != 'clear_sms' ? `Presso l'impianto di ${message.plant} al giorno ${message.timestamp} si è verificato l'allarme ${message.message}` : `Presso l'impianto di ${message.plant} al giorno ${message.timestamp} si è verificato l'allarme con testo libero ${message.message}`,
    })
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
}
@Component({
  templateUrl: 'availabilities.html',
  styleUrls: ['./mobile.component.scss']
})

export class AvailabilitiesIntD implements OnInit {
  private subscription: Subscription;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(
    public dialogRef: MatDialogRef<Emergenciesstatus>,
    public ApiService: ApiService,
    private storageService: ApiService,
    private emergenciesstatusService: EmergenciesstatusService,
    private changeDetectorRefs: ChangeDetectorRef,

    @Inject(MAT_DIALOG_DATA) public data) { }
  urls;
  chart2
  color = {
    white: '#fff',
    black: '#000',
    grey: '#7e8596',
    temperature: '#ED953A',
    humidity: '#7FB9F2',
    distance: '#FFF2AB',
    ec: '#C1FFBF',
    ph: '#fd5189',

  };
  pageSize = 10
  dataSource: MatTableDataSource<Emergenciesstatus>;
  itemCount = 1000
  displayedColumns: string[] = ['timestamp', 'plant', 'message'];
  speech

  ngOnInit() {
    this.speech = new Speech()
    this.speech
      .init({
        volume: 1,
        lang: "it-IT",
        rate: 0.7,
        pitch: 1,
        //'splitSentences': false,
        listeners: {
          onvoiceschanged: (voices) => {
          }
        }
      })
      .then((data) => {
      })
      .catch((e) => {
      });
    this.getData(0, this.pageSize)

  }
  public getServerData(event?: PageEvent) {
    this.getData(event.pageIndex, event.pageSize)
  }
  getData(pageIndex, pageSize) {
    this.storageService.getEmergenciesstatusmobile(pageIndex, pageSize, { timeFilter: "mobileTot" });
    this.dataSource = new MatTableDataSource(this.emergenciesstatusService.getEmergenciesstatus());
    this.subscription = this.emergenciesstatusService.emergenciesstatusChanged.subscribe(
      (emergenciesstatuss: Emergenciesstatus[]) => {
        this.dataSource = new MatTableDataSource(emergenciesstatuss);
        this.dataSource.sort = this.sort;
        this.changeDetectorRefs.detectChanges();
      }
    );
    this.subscription = this.emergenciesstatusService.emergenciesstatuscountChanged.subscribe(
      (emergenciesstatusscount: string) => {
        this.itemCount = parseInt(emergenciesstatusscount);
      }
    );
  }
  tts(message) {
    this.speech.speak({
      text: message.code != 'clear_sms' ? `Presso l'impianto di ${message.plant} al giorno ${message.timestamp} si è verificato l'allarme ${message.message}` : `Presso l'impianto di ${message.plant} al giorno ${message.timestamp} si è verificato l'allarme con testo libero ${message.message}`,
    })
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
}
@Component({
  templateUrl: 'callstatus.html',
  styleUrls: ['./mobile.component.scss']
})

export class DayCallstatusInt implements OnInit {
  private subscription: Subscription;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(
    public dialogRef: MatDialogRef<DayCallstatusInt>,
    public ApiService: ApiService,
    private storageService: ApiService,
    private callstatusService: CallstatusService,
    private changeDetectorRefs: ChangeDetectorRef,

    @Inject(MAT_DIALOG_DATA) public data) { }
  urls;
  chart2
  color = {
    white: '#fff',
    black: '#000',
    grey: '#7e8596',
    temperature: '#ED953A',
    humidity: '#7FB9F2',
    distance: '#FFF2AB',
    ec: '#C1FFBF',
    ph: '#fd5189',

  };
  pageSize = 10
  dataSource: MatTableDataSource<Callstatus>;
  itemCount = 1000
  displayedColumns: string[] = ['timestamp', 'plantid', 'message', 'available'];
  speech

  ngOnInit() {
    this.speech = new Speech()
    this.speech
      .init({
        volume: 1,
        lang: "it-IT",
        rate: 0.7,
        pitch: 1,
        //'splitSentences': false,
        listeners: {
          onvoiceschanged: (voices) => {
          }
        }
      })
      .then((data) => {
      })
      .catch((e) => {
      });
    this.getData(0, this.pageSize)

  }
  public getServerData(event?: PageEvent) {
    this.getData(event.pageIndex, event.pageSize)
  }
  getData(pageIndex, pageSize) {

    // si imposta il profilo corrente
    this.storageService.getCallstatusmobile(pageIndex, pageSize, { timeFilter: "mobile" });

    // si richiede all'apposito servizio la lista di pannelli e si popola la tabella, applicandone le opportune opzioni
    // (dal paginator, al sort)
    this.dataSource = new MatTableDataSource(this.callstatusService.getCallstatus());
    this.subscription = this.callstatusService.callstatusChanged.subscribe(
      (callstatus: Callstatus[]) => {
        this.dataSource = new MatTableDataSource(callstatus);
        this.dataSource.sort = this.sort;
        this.changeDetectorRefs.detectChanges();
      }
    );
    this.subscription = this.callstatusService.callstatuscountChanged.subscribe(
      (callstatusscount: string) => {
        this.itemCount = parseInt(callstatusscount);
      }
    );
  }
  calculatestatus(status) {
    if (status == "S" || status == "INSERTED" || status == "PENDING" || status == "SENT") {
      return 'yellow'
    } else if (status == "R" || status == "DELIVERED") {
      return 'green'
    } else if (status == "K" || status == "NOSENT" || status == "NOTDELIVERED") {
      return 'red'
    }
    else return ''
  }
  calculatestatuscolor(status) {
    if (status == "S" || status == "INSERTED" || status == "PENDING" || status == "SENT") {
      return 'black'
    } else if (status == "R" || status == "DELIVERED") {
      return 'white'
    } else if (status == "K" || status == "NOSENT" || status == "NOTDELIVERED") {
      return 'white'
    }
    else return ''
  }
  reSend(element) {
    this.storageService.resend({ number: element.number, plantid: element.plantidshort, code: element.message }).subscribe(result => {
    })
  }
  simplestatus(status) {
    if (status == "S" || status == "INSERTED" || status == "PENDING" || status == "SENT") {
      return 'Spedito'
    } else if (status == "R" || status == "DELIVERED") {
      return 'Ricevuto'
    } else if (status == "K" || status == "NOSENT" || status == "NOTDELIVERED") {
      return 'Non spedito/ricevuto'
    }
    else return ''
  }
  tts(message) {
    this.storageService.getAlarmcodesList().subscribe((data) => {
      this.speech.speak({
        text: data.map(a => a.includes(message.message) ? a : false).filter(Boolean).length > 0 ? `Presso l'impianto di ${message.plantid} al giorno ${message.timestamp} si è verificato l'allarme ${message.message}` : `Presso l'impianto di ${message.plantid} al giorno ${message.timestamp} si è verificato l'allarme con testo libero ${message.message}`,
      })
    })
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
}